/**
 * Eén regel voor links die uit instellingen of teksten komen (podcast, nieuwsbrief, beelden, media):
 * alleen https. http mag alleen tijdens ontwikkelen, en dan alleen naar localhost.
 * `mailto` alleen waar dat zin heeft (een knop in de nieuwsbrief). Al het andere → `null`.
 */
type Options = { mailto?: boolean; dev?: boolean }

const isDev = (): boolean => {
  try {
    return Boolean(import.meta.env?.DEV)
  } catch {
    return false
  }
}

export function safeUrl(raw: string | null | undefined, { mailto = false, dev = isDev() }: Options = {}): string | null {
  const url = raw?.trim()
  if (!url) return null
  if (mailto && /^mailto:[^\s@]+@[^\s@]+$/i.test(url)) return url
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return null
  }
  if (parsed.protocol === 'https:' && parsed.hostname) return url
  if (dev && parsed.protocol === 'http:' && (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1')) return url
  return null
}
